import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { BedrockCatalogModel } from "../OrgLlmProviderRecord";

import { orgQueryKeys } from "./orgQueryKeys";

const FIFTEEN_MINUTES_MS = 15 * 60 * 1000;

/**
 * The deployment's whole Bedrock catalog, `catalog_only` models included.
 * Roboto-admin only: pass `enabled: false` for anyone else so the request is
 * never made.
 */
export function useBedrockCatalog({
  enabled = true,
}: { enabled?: boolean } = {}) {
  const { orgService } = useDomainServices();

  return useQuery<BedrockCatalogModel[], Error>({
    queryKey: orgQueryKeys.bedrockCatalog(),
    queryFn: ({ signal }) =>
      orgService.getBedrockCatalog({ abortSignal: signal }),
    staleTime: FIFTEEN_MINUTES_MS,
    enabled,
  });
}
